/**
 * Tonalité visuelle par type d'offre.
 * `soutien` (cours annuels) → indigo (primary)
 * `stage` (stages vacances) → fuchsia (accent)
 *
 * Utiliser partout où on doit distinguer visuellement les 2 types
 * (planning, cards, modales, badges, headers de classe...).
 */

export type OfferTone = "soutien" | "stage";

export interface OfferToneClasses {
  /** Gradient pour headers de modales / cards mises en avant */
  gradient: string;
  /** Solide pour les boutons CTA */
  solid: string;
  /** Solide hover */
  solidHover: string;
  /** Background subtil (50) */
  bg: string;
  /** Texte coloré (600/700) */
  text: string;
  /** Bordure subtile (100/200) */
  border: string;
  /** Ring focus (50) */
  ring: string;
  /** Variante `StatusBadge` correspondante */
  badgeVariant: "info" | "cycle";
}

export const OFFER_TONE: Record<OfferTone, OfferToneClasses> = {
  soutien: {
    gradient: "bg-gradient-to-br from-indigo-500 to-blue-600",
    solid: "bg-indigo-600 text-white",
    solidHover: "hover:bg-indigo-700",
    bg: "bg-indigo-50",
    text: "text-indigo-600",
    border: "border-indigo-100",
    ring: "focus:ring-indigo-50",
    badgeVariant: "info",
  },
  stage: {
    gradient: "bg-gradient-to-br from-fuchsia-500 to-purple-600",
    solid: "bg-fuchsia-600 text-white",
    solidHover: "hover:bg-fuchsia-700",
    bg: "bg-fuchsia-50",
    text: "text-fuchsia-600",
    border: "border-fuchsia-100",
    ring: "focus:ring-fuchsia-50",
    badgeVariant: "cycle",
  },
};

/**
 * Normalise les variantes utilisées dans le code (`"fuchsia" | "indigo"`,
 * `"annual_course" | "vacation_course"`, etc.) vers la clé canonique.
 */
export function resolveOfferTone(value: string | undefined | null): OfferTone {
  if (!value) return "soutien";
  const v = value.toLowerCase();
  if (v === "stage" || v === "fuchsia" || v.includes("vacation")) return "stage";
  return "soutien";
}
